import * as THREE from "three";
import type { ShapeSurface } from "../types";
import { sourceCanvas, surfaceTileMeters } from "./surfaceTextures";

const textures = new Map<string, THREE.Texture>();

/** La matière en texture répétée, ancrée en mètres dans la scène du décor (u = x, v = -z). */
export function surfaceTexture3d(surface: ShapeSurface, tint: string | null): THREE.Texture {
  const scale = surface.scale ?? "normal";
  const key = `${surface.material}:${scale}:${tint ?? ""}`;
  const cached = textures.get(key);
  if (cached) return cached;
  const texture = new THREE.CanvasTexture(sourceCanvas(surface.material, tint));
  texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
  const meters = surfaceTileMeters(surface.material, scale);
  texture.repeat.set(1 / meters, 1 / meters);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.anisotropy = 8;
  textures.set(key, texture);
  return texture;
}
